var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 5.03832C18.8332 4.12165 18.0832 3.37165 17.1665 3.37165H3.83317C2.9165 3.37165 2.1665 4.12165 2.1665 5.03832V15.0383C2.1665 15.955 2.9165 16.705 3.83317 16.705H17.1665C18.0832 16.705 18.8332 15.955 18.8332 15.0383V5.03832ZM17.1665 5.03832L10.4998 9.20498L3.83317 5.03832H17.1665ZM17.1665 15.0383H3.83317V6.70498L10.4998 10.8717L17.1665 6.70498V15.0383Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEnvelope);
export default __webpack_public_path__ + "static/media/email-envelope.c742733e55f49a847aeca38fc9e1c537.svg";
export { ForwardRef as ReactComponent };